const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
//const OKButtonUpload = require('components/commons/OKButtonUpload/OKButtonUpload');

const OKStatusIcon = require('components/commons/OKStatusIcon/OKStatusIcon');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');

// @ actions
const documentationCenterActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

class MortgageRequestOperativeDocumentationItem extends React.Component {
    constructor(props) {
        super(props);

        this.handleDownload = this.handleDownload.bind(this);
        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
    }

    getDocumentActionStatus(documentStatus, replaceable) {
        const addButton = replaceable && this.buildAddLink(documentStatus);

        let downloadButton = '';

        if (
            documentStatus &&
            documentStatus !== DOCUMENTS_STATUS.NONE &&
            documentStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
            documentStatus !== DOCUMENTS_STATUS.NO_VALIDO &&
            documentStatus !== DOCUMENTS_STATUS.EXENTO
        ) {
            downloadButton = this.buildDownloadButton();
        }

        return (
            <div className="mortgage-request-operative-documentation__item-actions">
                {addButton}
                {downloadButton}
            </div>
        );
    }

    buildAddLink(documentStatus) {
        const { docCenterState, summaryDocumentationState } = this.props;
        const loadingStateUploadBtn = docCenterState.get('uploadFileButonState') || summaryDocumentationState.get('isFetching');
        const btnState = this.buildText(documentStatus);

        return (
            <div className={`mortgage-request-operative-documentation__add-link-container ${btnState.class}`}>
                <div className="row">
                    <OKButton Upload
                        onSelectFile={this.handleOnChangeFile}
                        isLoading={loadingStateUploadBtn}
                        hasNotFile={btnState.text}
                    />
                </div>
            </div>
        );
    }

    buildDownloadButton() {
        const { item, docCenterState } = this.props;

        const downloadButton = (
            <div className="mortgage-request-operative-documentation__download-button-container">
                <OKButton
                    id={item.documentType}
                    onClick={this.handleDownload}
                    size="small"
                    modifier="task"
                    disabled={docCenterState.getIn(['isFetching', item.documentType])}
                    loading={docCenterState.getIn(['isFetching', item.documentType])}
                >
                    <i className="icon-descargar" />
                </OKButton>
            </div>
        )
        return (
            <OKTooltip
                content="mortgageRequestDocumentationCenter-downloadIcon"
                offset={[0, -15]}
                target={downloadButton}
            />
        );
    }

    buildText(documentStatus) {
        if (documentStatus && (documentStatus === DOCUMENTS_STATUS.NONE || documentStatus === DOCUMENTS_STATUS.PEND_APORTAR)) {
            return {text: true, class: "pull-rigth"}
        } else {
            return {text: false, class: "pull-left"}
        }
    }

    handleDownload(evt) {
        evt.preventDefault();

        const { item, getDocument } = this.props;

        getDocument({
            documentType: item.documentType
        });
    }

    handleOnChangeFile(fileState) {
        const { uploadFile } = this.props;
        fileState && uploadFile(fileState);
    }

    render() {
        const { documentLabel, documentStatus, replaceable } = this.props.item;

        const documentStatusIcon = OKStatusIcon({
            status: documentStatus,
            wrapperClasses: "mortgage-request-operative-documentation__item-doc",
            documentTypeLabel: formatText(documentLabel)
        });

        const documentActionStatus = this.getDocumentActionStatus(documentStatus, replaceable);

        return (
            <li className="mortgage-request-operative-documentation__item">
                <div className="mortgage-request-operative-documentation__item-label">
                    {documentStatusIcon}
                </div>
                {documentActionStatus}
            </li>
        );
    }
}

MortgageRequestOperativeDocumentationItem.propTypes = {
    docCenterState: PropTypes.object,
    summaryDocumentationState: PropTypes.object,
    getDocument: PropTypes.func,
    getNSDocuments: PropTypes.func,
    item: PropTypes.object.isRequired,
    uploadFile: PropTypes.func
}

module.exports.MortgageRequestOperativeDocumentationItem = connect(state => (
    {
        docCenterState: state.mortgageRequestDocumentationCenter,
        summaryDocumentationState: state.mortgageRequestSummaryDocumentation
    }),
    {
        getDocument: documentationCenterActions.getDocument,
        getNSDocuments: documentationCenterActions.getNSDocuments,
        uploadFile: documentationCenterActions.uploadFile
    }
)(MortgageRequestOperativeDocumentationItem);
